import clienteAxios from "../../../config/axios";
import { FechaExacta } from "../../../config/const";

export const columns = [
  {
    id: "h_id",
    label: "Codigo",
    minWidth: 2,
    tipo: "string",
    propiedad: "h_id",
  },
  {
    id: "lc_nombre_mascota",
    label: "Paciente",
    minWidth: 2,
    tipo: "string",
    propiedad: "lc_nombre_mascota",
    variante: "autocompleteDinamico",
    propiedadesMostrar: 2,
    campoData1: "mascNombre",
    campoData2: "mascPerNombre",
    getData: async (data) => {
      const res = await clienteAxios.get(`/mascotas/filtro/0?search=${data}`);
      return res;
    },
  },
  {
    id: "lc_id_propietario",
    label: "Propietario",
    minWidth: 150,
    tipo: "string",
    propiedad: "lc_id_propietario",
    variante: "autocompleteDinamico",
    propiedadesMostrar: 2,
    campoData1: "perDocNumero",
    campoData2: "perNombre",
    getData: async (data) => {
      const res = await clienteAxios.get(
        `/proveedores/filtro/0?search=${data}&estado=CLIENTE`
      );
      return res;
    },
  },
  {
    id: "lc_id_medico",
    label: "Doctor",
    minWidth: 150,
    tipo: "string",
    propiedad: "lc_id_medico",
    variante: "autocompleteDinamico",
    propiedadesMostrar: 2,
    campoData1: "perDocNumero",
    campoData2: "perNombre",
    getData: async (data) => {
      const res = await clienteAxios.get(
        `/proveedores/filtro/0?search=${data}&estado=VETERINARIO`
      );
      return res;
    },
  },
  {
    id: "lc_observacion",
    label: "Observación",
    minWidth: 2,
    tipo: "",
    propiedad: "lc_observacion",
  },
  {
    id: "h_usuario",
    label: "User",
    minWidth: 2,
    tipo: "string",
    propiedad: "h_usuario",
  },
  {
    id: "h_fec_reg",
    label: "Fec Upd",
    minWidth: 50,
    tipo: "numero",
    propiedad: "h_fec_reg",
  },
];
export const validacion = (item, setitem, seterror) => {
  const { ubicacion, fechas } = item;

  if (ubicacion.trim() === "" || fechas.length === 0  ) {
    seterror({
      ubicacion: ubicacion.trim() === "",
      fechas: fechas.length === 0, 
    });
    return true;
  }
};
export const objectDefault = {
  h_id: 0,
  h_id_ubicacion: 1,
  h_anio_mes: "",
  h_fec_reg: "",
  ubicacion: "",
  puesto: "",

  fechas: [
    // {
    //   desde: "2025-07-17 06:00:00",
    //   hasta: "2025-07-17 14:00:00",
    //   dht_id_tipo_turno: 1,
    //   dht_id: 1,
    //   dht_id_horario: 1,
    //   dht_color: null,
    //   persona: 1,
    // },
  ],
};
